import { render, staticRenderFns } from "./UserGroupsModal.vue?vue&type=template&id=326409ba&scoped=true"
import script from "./UserGroupsModal.vue?vue&type=script&lang=ts"
export * from "./UserGroupsModal.vue?vue&type=script&lang=ts"
import style0 from "./UserGroupsModal.vue?vue&type=style&index=0&id=326409ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326409ba",
  null
  
)

export default component.exports